import api from '../api/client';

export const pisteirosService = {
  listar: (organizadorId, incluirInativos = false) => {
    const params = incluirInativos ? '?incluir_inativos=true' : '';
    return api.get(`/organizadores/${organizadorId}/pisteiros${params}`);
  },

  criar: (organizadorId, dados) => api.post(`/organizadores/${organizadorId}/pisteiros`, dados),

  atualizar: (organizadorId, pisteiroId, dados) => api.put(`/organizadores/${organizadorId}/pisteiros/${pisteiroId}`, dados),

  excluir: (organizadorId, pisteiroId) => api.delete(`/organizadores/${organizadorId}/pisteiros/${pisteiroId}`),

  toggleAtivo: (organizadorId, pisteiroId) => api.patch(`/organizadores/${organizadorId}/pisteiros/${pisteiroId}/toggle-ativo`),

  relatorio: (organizadorId, filtros = {}) => {
    const params = new URLSearchParams();
    if (filtros.leilao_id) params.append('leilao_id', filtros.leilao_id);
    if (filtros.data_inicio) params.append('data_inicio', filtros.data_inicio);
    if (filtros.data_fim) params.append('data_fim', filtros.data_fim);
    if (filtros.pisteiro_id) params.append('pisteiro_id', filtros.pisteiro_id);
    if (filtros.situacao) params.append('situacao', filtros.situacao);
    if (filtros.ordenar_por) params.append('ordenar_por', filtros.ordenar_por);
    const query = params.toString();
    return api.get(`/organizadores/${organizadorId}/relatorios/receita-pisteiros${query ? `?${query}` : ''}`);
  },

  relatorioPdf: (organizadorId, filtros = {}) => {
    const params = new URLSearchParams();
    if (filtros.leilao_id) params.append('leilao_id', filtros.leilao_id);
    if (filtros.data_inicio) params.append('data_inicio', filtros.data_inicio);
    if (filtros.data_fim) params.append('data_fim', filtros.data_fim);
    if (filtros.pisteiro_id) params.append('pisteiro_id', filtros.pisteiro_id);
    if (filtros.situacao) params.append('situacao', filtros.situacao);
    if (filtros.ordenar_por) params.append('ordenar_por', filtros.ordenar_por);
    const query = params.toString();
    return api.get(`/organizadores/${organizadorId}/relatorios/receita-pisteiros/pdf${query ? `?${query}` : ''}`, { responseType: 'blob' });
  },
};

